<mat-form-field color="accent" [appearance]="'fill'" class="app-form-field">
    <mat-label>{{ labelT | translate }}</mat-label>
    <input matInput [value]="value" disabled autocomplete="not" />
</mat-form-field>